import { render } from "./InfosLayout.vue?vue&type=template&id=3994c240&scoped=true"
import script from "./InfosLayout.vue?vue&type=script&lang=js"
export * from "./InfosLayout.vue?vue&type=script&lang=js"

import "./InfosLayout.vue?vue&type=style&index=0&id=3994c240&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3994c240"]])

export default __exports__